import { Component, OnInit, Input, Output, OnChanges, EventEmitter, SimpleChange, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { JourneyService } from '../../Services/journey.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
declare const $;

@Component({
  selector: 'app-game-characters',
  templateUrl: './game-characters.component.html',
  styleUrls: ['./game-characters.component.css']
})
export class GameCharactersComponent implements OnChanges, OnDestroy, OnInit {
  @Input() characterSpeech: any;
  @Input() sceneInfoCharacters: any;
  @Input() sceneAudios: any;
  @Input() sceneCharacters: any;
  @Input() isGameRestart: boolean;
  @Input() disableGameResponse: any;
  @Input() resConfig: any;
  @Input() usrGameCfgData: any;
  @Input() no_of_attempts: any;
  gameTranscationMetadata: any;
  // @Input() screenOrientataion: any;
  @Input() step_id: any;
  @Input() userID: any;
  @Input() community_id: any;
  @Input() journey_id: any;
  @Input() fromJourneyComponent: any;
  @Input() characterSpeechForSettingResponse: any;
  @Output() responseSource = new EventEmitter<any>();
  @Output() gameFinished = new EventEmitter<any>();
  @Output() gameResponseDisable = new EventEmitter<any>();
  @Output() showScoreResponse = new EventEmitter<any>();
  @Output() playGlobalAudio = new EventEmitter<any>();
  @Output() feedBackCFGText = new EventEmitter<any>();
  @Output() isDisplayNotificationDivText = new EventEmitter<any>();
  @Output() gameKeyLearningSectionHide = new EventEmitter<boolean>();
  @Output() notifyToGameCharacterComponent = new EventEmitter<boolean>();
  @Output() gameRestartFromChild = new EventEmitter<boolean>();
  @Output() eventForSettingRepsone = new EventEmitter<any>();
  @Output() eventForScaling = new EventEmitter<any>();
  @ViewChild('responseBgEle') responseBgElement: ElementRef;
  screenOrientataion: any = window.orientation;
  volume;
  currentGameResponse: string;
  playResponseAudioFlag: boolean = false;
  tempArr;
  count;
  i = 1;
  talking;
  eyeBlinking;
  image: HTMLElement | any;
  x;
  defaultAnimationArray = [];
  intervalsArray = [];
  timeOutsArray = [];
  playedAudiosArray = [];
  interactionIndex = 0;
  prefIndex = 0;
  audioForIndex = 0;
  responseDisable;
  summeryFeedback = false;
  reviewAndFeedBackArray: Array<any> = [];
  expressionIndex = 0;
  responses: Array<any> = [];
  currentGameChoices: Array<any> = [];
  clearDefaultExp = [];
  defaultExpressionList = [];
  defaultExpressionListWithName = [];
  cfgFeedBackFlag: boolean = false;
  isCfgFeedBackInvalid: boolean = false;
  cfgFeedBackText: string = '';
  screenWidth: number = 1366;
  screenHeight: number;
  gameOverStatus: boolean = false;
  config1 = {
    textSize: 6,
    numberSize: 18,
    width: 55,
    height: 45,
    top: 63,
    left: 17,
    mtop: -45,
    lheight: 13
  }
  config2 = {
    textSize: 12,
    numberSize: 30,
    width: 57,
    height: 10,
    top: 43,
    left: 27,
    mtop: 10,
    lheight: 22
  }
  showEmbededComponents: boolean = false;
  showToolTip: boolean;
  isAlertShow: boolean = false;
  progressValue: number = 0;
  lastPart: string;
  userFinalResponses: any;
  isHighlightedChoiceDisplay: boolean;
  validationMsg: string;
  
  constructor(private journeyService: JourneyService) {
  }

  ngOnInit() {

    // Image Tag to load image
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    this.image = document.getElementById('seqImages');
    // create variable to traverse images by given number
    this.i = 1;
    this.talking;
    this.eyeBlinking;
    // this.multipleCharacter();
    this.currentGameResponse = 'Scene';
    const element = this.responseBgElement.nativeElement;
    const computedStyle = window.getComputedStyle(element);

    if (computedStyle.position === 'absolute') {
      // alert("successmodal show")
      this.eventForScaling.emit({ 'value': 'scale120' })
    }
  }

  ngAfterViewInit() {
    // alert("view init called");
    let top = document.getElementById('top');
    if (top) {
      top.scrollIntoView();
      top = null;
    }
  }

  shuffleArray(d) {
    for (var c = d.length - 1; c > 0; c--) {
      var b = Math.floor(Math.random() * (c + 1));
      var a = d[c];
      d[c] = d[b];
      d[b] = a;
    }
    return d
  };

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    //alert(this.isGameRestart);
    if (changes.characterSpeechForSettingResponse && changes.characterSpeechForSettingResponse.currentValue) {
      if (this.characterSpeech.options.option) {
        if (this.characterSpeech.options.option.length <= 0) {
          var string = this.currentGameResponse;
          var count = string.split('-');
          let tendancyScene;
          if (count.length > 2) {
            tendancyScene = string.split('-')[1];
          } else {
            tendancyScene = string.split('-')[0];
          }
          let lastPart = count[count.length - 1];
          this.lastPart = lastPart;
          //if(document.getElementById(lastPart))
          //document.getElementById(lastPart).style.border = '2px solid #F8941E';
          this.eventForSettingRepsone.emit({ 'choice': tendancyScene })
          if (this.characterSpeechForSettingResponse) {
            this.userFinalResponses = this.characterSpeechForSettingResponse.options.option;
            this.responseDisable = true;
            this.isHighlightedChoiceDisplay = true;
          }
        } else {
          this.characterSpeech.options.allowRandomization == "true" ? this.responses = this.shuffleArray(this.characterSpeech.options.option) : this.responses = this.characterSpeech.options.option;
        }
      }
    } else {
      if (this.fromJourneyComponent)
        this.gameOverStatus = false;
      this.progressInc();
      this.showEmbededComponents = false;
      this.screenWidth = screen.width || window.screen.width;
      this.screenHeight = screen.height || window.screen.height;
      console.log("this.screenOrientataion: ", this.screenOrientataion);
      this.defaultAnimationArray = [];
      this.clearDefaultExp = [];
      this.summeryFeedback = false;
      this.cfgFeedBackFlag = false;
      this.interactionIndex = 0;
      this.progressValue = 0;
      this.isHighlightedChoiceDisplay = false;
      this.userFinalResponses = [];
      this.lastPart = '';
      if (this.isGameRestart) {
        this.lastPart = '';
        this.currentGameChoices = [];
        this.isGameRestart = false;
        this.gameRestartFromChild.emit(false);
        this.cfgFeedBackFlag = false;
        this.isDisplayNotificationDivText.emit({ flag: true });
        this.currentGameResponse = 'Scene';
        //this.disableGameResponse = 'false';
        this.gameOverStatus = false;
        this.userFinalResponses = [];

        //this.characterSpeechForSettingResponse = undefined;
        this.progressInc();
      }
      console.log("------------sceneCharacters---------------");
      console.log(this.sceneCharacters);

      this.responseDisable = this.disableGameResponse == 'true' ? true : false;
      console.log("------------disableGameResponse---------------");
      console.log(this.disableGameResponse);
      // Clear all set timeouts
      for (let j = 0; j < this.timeOutsArray.length; j++) {
        clearTimeout(this.timeOutsArray[j]);
      }
      // Clear all set intervals.
      for (let j = 0; j < this.intervalsArray.length; j++) {
        clearInterval(this.intervalsArray[j]);
      }

      for (let j = 0; j < this.defaultExpressionList.length; j++) {
        clearInterval(this.defaultExpressionList[j]);
      }

      // Clear all set intervals.
      for (let j = 0; j < this.clearDefaultExp.length; j++) {
        clearInterval(this.clearDefaultExp[j]);
      }
      // Pause all played audios.
      for (let i = 0; i < this.playedAudiosArray.length; i++) {
        this.playedAudiosArray[i].pause();
      }
      console.log("character option array is", this.characterSpeech.options.option);
      console.log("radomization value is", this.characterSpeech.options.allowRandomization);
      if (this.characterSpeech.options.option) {
        if (this.characterSpeech.options.option.length <= 0) {
          var string = this.currentGameResponse;
          var count = string.split('-');
          let tendancyScene;
          if (count.length > 2) {
            tendancyScene = string.split('-')[1];
          } else {
            tendancyScene = string.split('-')[0];
          }
          let lastPart = count[count.length - 1];
          this.lastPart = lastPart;
          //if(document.getElementById(lastPart))
          //document.getElementById(lastPart).style.border = '2px solid #F8941E';
          this.eventForSettingRepsone.emit({ 'choice': tendancyScene })
          if (this.characterSpeechForSettingResponse) {
            this.userFinalResponses = this.characterSpeechForSettingResponse.options.option;
            this.responseDisable = true;
            this.isHighlightedChoiceDisplay = true;
          }
        } else {
          this.characterSpeech.options.allowRandomization == "true" ? this.responses = this.shuffleArray(this.characterSpeech.options.option) : this.responses = this.characterSpeech.options.option;
        }
      }
      this.playedAudiosArray = [];
      this.intervalsArray = [];
      this.defaultExpressionList = [];
      this.defaultExpressionListWithName = [];
      this.timeOutsArray = [];
      if (this.characterSpeech) {
        this.multipleCharacter();
      }
    }
  }
  progressInc() {
    setTimeout(() => {
      if (this.progressValue >= 100) {
        this.progressValue = 0;
      }
      else {
        this.progressValue += 10;
      }
      if (this.progressValue < 100) {
        this.progressInc();
      }
    }, 1000);
  }
  multipleCharacter() {

    this.prefIndex = 0;
    $("#" + this.characterSpeech.rootId).empty();
    $("#" + this.characterSpeech.rootId).append('<div><audio style="display:none" id="myfirstaudio" controls><source src="" type="audio/mpeg"></audio></div>');
    $("#" + this.characterSpeech.rootId).css('background-image', 'url(' + this.sceneCharacters.bgImage.src + ')');
    //character creation
    var c, clist;
    //clist=this.characterSpeech.characterSpeech;
    clist = [];
    for (let i = 0; i < this.sceneInfoCharacters.length; i++) {
      let found = this.characterSpeech.characterSpeech.find(char => char.name == this.sceneInfoCharacters[i].charName);
      if (found) {
        clist.push(found);
      }
    }
    for (c = 0; c < clist.length; c++) {
      var charId = "myimg" + c;
      var ctooltipId = "tooltip" + c;
      if (this.sceneInfoCharacters && this.sceneInfoCharacters.length > 2) {
        $("#" + this.characterSpeech.rootId).append('<div><div id="' + charId + '"><div class="parentbox"><div id="' + ctooltipId + '" class="speech-bubble-3Char childbox"></div></div></div></div>');
        $(".speech-bubble-3Char").css("display", "none");
      } else {
        $("#" + this.characterSpeech.rootId).append('<div><div id="' + charId + '"><div class="parentbox"><div id="' + ctooltipId + '" class="speech-bubble childbox"></div></div></div></div>');
        $(".speech-bubble").css("display", "none");
      }
      if (clist[c].expression[1] == 'Absent_Absent' || clist[c].entry) {
        $("#" + charId).css('background-image', 'url()');
      } else {
        $("#" + charId).css('background-image', 'url(' + this.sceneCharacters[clist[c].name + '_' + clist[c].expression[0]].src + ')');
      }
      $("#" + charId).css('height', '320px');
      $("#" + charId).css('width', '100%');
      // $("#"+charId).css('margin-left','5%');
      $("#" + charId).css('background-position', '0% 38%');
      $("#" + charId).css('position', 'absolute');
      this.tempArr = this.characterSpeech.speechPreference.split('_');
      this.x = 0;
      this.count = 1;
      this.setInetrvalAn(charId, c, clist[c].frames[0], clist[c].fidelity[0]);
    }
    $("#" + this.characterSpeech.rootId).append('<div class="narratorDialogue"></div>');
    $('.narratorDialogue').css('display', 'none');
    let totalChar = this.sceneInfoCharacters.length;
    this.setLeftPost(totalChar);
    let iOSVer = /iPad|iPhone|iPod/.test(navigator.platform);
    if (this.screenOrientataion == 90) {
      if (totalChar == 1) {
        // $(".parentbox").css('left','55.5%');
        //$(".parentbox").css('left','67.5%');     
        // if ((window.navigator.userAgent.match(/iP(hone|od|ad)/)) || iOSVer) {
        //   document.getElementById('myimg0').classList.add('myimg0_One');
        //   document.getElementsByClassName('parentbox')[0].classList.add('myImgParentBox');
        // }
        $('#myimg0').addClass('myimg0_One');
        $('.parentbox').addClass('myImgParentBox');
      } else if (totalChar == 2) {
        // if ((window.navigator.userAgent.match(/iP(hone|od|ad)/)) || iOSVer) {
        //   document.getElementById('myimg0').classList.add('myimg0_Two');
        //   document.getElementById('myimg1').classList.add('myimg1_Two');
        //   document.getElementsByClassName('parentbox')[0].classList.add('myImgParentBox_Two');
        // }
        $('#myimg0').addClass('myimg0_Two');
        $('#myimg1').addClass('myimg1_Two');
        $('.parentbox').addClass('myImgParentBox_Two');
      } else if (totalChar == 3) {
        if (this.screenWidth < 665 && this.screenWidth > 630) {
          // if ((window.navigator.userAgent.match(/iP(hone|od|ad)/)) || iOSVer) {
          //   document.getElementById('myimg0').classList.add('myimg0_Three');
          //   document.getElementById('myimg1').classList.add('myimg1_Three');
          //   document.getElementById('myimg2').classList.add('myimg2_Three');
          //   document.getElementsByClassName('parentbox')[0].classList.add('myImgParentBox_Three');
          // }
          $('#myimg0').addClass('myimg0_Three');
          $('#myimg1').addClass('myimg1_Three');
          $('#myimg2').addClass('myimg2_Three');
          $('.parentbox').addClass('myImgParentBox_Three');
        } else if (this.screenWidth < 1000) {
          // if ((window.navigator.userAgent.match(/iP(hone|od|ad)/)) || iOSVer) {
          //   document.getElementById('myimg0').classList.add('myimg0_Three');
          //   document.getElementById('myimg1').classList.add('myimg1_Three');
          //   document.getElementById('myimg2').classList.add('myimg2_Three');
          //   document.getElementsByClassName('parentbox')[0].classList.add('myImgParentBox_Three');
          // }
          $('#myimg0').addClass('myimg0_Three');
          $('#myimg1').addClass('myimg1_Three');
          $('#myimg2').addClass('myimg2_Three');
          $('.parentbox').addClass('myImgParentBox_Three');
        } else {
          console.log("orientaion 90----");
          // $(".speech-bubble").css('width','145px');
          $(".speech-bubble-3Char").css('width', '145px');
          // $(".parentbox").css('left','48.5%');
          $(".parentbox").css('left', '48.5%');
        }
      } else if (totalChar == 4) {
        // $(".speech-bubble").css('width','150px');
        $(".speech-bubble-3Char").css('width', '150px');
        $(".parentbox").css('left', '51.5%');
      }
    } else {
      if (totalChar == 4) {
        // $(".speech-bubble").css('width','120px');
        $(".speech-bubble-3Char").css('width', '120px');
        $(".parentbox").css('left', '40%');
      } else if (totalChar == 3) {
        $(".speech-bubble-3Char").css('width', '145px');
        // $(".speech-bubble").css('width','145px');
        $(".parentbox").css('left', '48.5%');
      }
    }
    if (this.characterSpeech.endNode == 'true' || this.characterSpeech.endNode == true) {
      this.gameOverStatus = true;
      let cfgfedTxt = this.cfgFeedBackText;
      this.showScoreResponse.emit({ gameOver: true, isComeFrom: 'loadScene' })
      this.gameFinished.emit({ finished: true, Score: this.characterSpeech.summaryFeedback.score, Path: this.currentGameResponse, Choice: this.currentGameChoices, feedback_text: cfgfedTxt });
    }
    this.loadScene();
  }

  setInetrvalAn(charId, c, width, fidelity) {
    let fps = 1000 / fidelity;
    let animation = setInterval(() => {
      this.playSpriteImage(charId, width);
    }, fps);
    this.defaultAnimationArray.push(animation);
    this.intervalsArray.push(animation);
    this.clearDefaultExp[c] = animation;
  }

  setLeftPost(totalChar) {
    let main = 100;
    let divisioncount = totalChar;
    let chasize = 100;
    let sectionsize = main / divisioncount;
    let leftaddjest = sectionsize - chasize;
    leftaddjest = leftaddjest / 2;
    if (this.screenOrientataion == 90) {
      //---------- For  mobile view
      for (let s = 0; s < totalChar; s++) {
        let left = 0;
        left = left + leftaddjest;
        left = left + (sectionsize * s);
        $("#myimg" + s).css('left', left + '%');
      }
    } else {
      //---------- In Desktop view
      for (let s = 0; s < totalChar; s++) {
        let left = -1;
        left = left + leftaddjest;
        left = left + (sectionsize * s);
        $("#myimg" + s).css('left', left + '%');
      }
    }
  }

  playSpriteImage(id, width) {
    $("#" + id).css('background-position', '' + this.x + 'px 38%');
    if (this.count == width - 1) {
      this.x = 0;
      this.count = 1;
    } else {
      this.count = this.count + 1;
      this.x = this.x - 960;
    }
  }

  defaultExpression(charId, url, Frames, fidelity) {
    let x = 0;
    let count = 1;
    $("#" + charId).css('background-position', '' + x + 'px 0%');
    $("#" + charId).css('background-image', 'url(' + url + ')');
    let fps = 1000 / fidelity;
    // start animation with interval
    let myInt1 = setInterval(() => {
      $("#" + charId).css('background-position', '' + x + 'px 0%');
      if (count == Frames) {
        count = 1;
        x = 0;
      } else {
        count = count + 1;
        x = x - 960;
      }
    }, fps);
    //this.intervalsArray.push(myInt1);
    let obj = {
      name: charId,
      val: myInt1
    };
    this.defaultExpressionList.push(myInt1);
    this.defaultExpressionListWithName.push(obj);
    this.clearDefaultExp[this.tempArr[this.prefIndex]] = myInt1;
  }

  expressionWithAudio(charId, url, Frames, duration, fidelity, callback) {
    let x = 0;
    let count = 1;
    $("#" + charId).css('background-position', '' + x + 'px 0%');
    $("#" + charId).css('background-image', 'url(' + url + ')');
    let fps = 1000 / fidelity;
    // start animation with interval
    let myInt1 = setInterval(() => {
      $("#" + charId).css('background-position', '' + x + 'px 0%');
      if (count == Frames) {
        count = 1;
        x = 0;
      } else {
        count = count + 1;
        x = x - 960;
      }
    }, fps);
    this.intervalsArray.push(myInt1);
    let mySetTimeout = setTimeout(() => {
      clearInterval(myInt1);
      callback();
    }, duration);
    this.timeOutsArray.push(mySetTimeout);
  }

  expressionWithoutAudio(charId, url, Frames, fidelity, callback) {
    let x = 0;
    let count = 1;
    $("#" + charId).css('background-position', '' + x + 'px 0%');
    $("#" + charId).css('background-image', 'url(' + url + ')');
    let fps = 1000 / fidelity;
    // start animation with interval
    let myInt1 = setInterval(() => {
      $("#" + charId).css('background-position', '' + x + 'px 0%');
      if (count == Frames) {
        clearInterval(myInt1);
        callback();
      } else {
        count = count + 1;
        x = x - 960;
      }
    }, fps);
    this.intervalsArray.push(myInt1);
  }

  loadScene() {
    //this.disableGameResponse = true;
    if (this.responses.length == 0)
      this.responseDisable = false;

    this.playResponseAudioFlag = false;
    this.gameResponseDisable.emit({ response: this.responseDisable });
    this.audioForIndex = 0;
    this.expressionIndex = 1;
    clearInterval(this.defaultAnimationArray[this.tempArr[this.prefIndex]]);
    let audioNum = 0;
    if (this.prefIndex != this.characterSpeech.characterSpeech.length && this.prefIndex <= this.characterSpeech.characterSpeech.length) {
      if (this.tempArr[this.prefIndex] == "-1") {
        if (this.characterSpeech.characterSpeech[this.interactionIndex].name != 'Narrator') {
          this.prefIndex++;
          this.interactionIndex++;
          if (this.tempArr[this.prefIndex] == "-1") {
            this.loadScene();
          }
        }
        if (this.prefIndex >= this.characterSpeech.characterSpeech.length) {
          this.loadScene();
        } else {
          if (this.characterSpeech.characterSpeech[this.interactionIndex].name == 'Narrator') {
            this.narratorCharacterPlay(audioNum);
          } else {
            this.playCharacter(audioNum);
          }
        }
      } else {
        if (this.characterSpeech.characterSpeech[this.interactionIndex].name == 'Narrator') {
          this.narratorCharacterPlay(audioNum);
        } else {
          this.playCharacter(audioNum);
        }
      }
    } else {
      this.responseDisable = false;
      this.playResponseAudioFlag = true;
      this.gameResponseDisable.emit({ response: this.responseDisable });
      console.log("this.screenOrientataion", this.screenOrientataion);
      if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
        $('.responseBgContainer').css('top', '0%');
      }
      if (this.characterSpeech.endNode == 'true' || this.characterSpeech.endNode == true) {
        let flagNoOp = false;
        if (this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Games && this.resConfig[0].Games.length > 0) {
          if (this.resConfig[0].Games[0].feedback_text && this.resConfig[0].Games[0].feedback_text.visible && this.no_of_attempts == 0) {
            if (this.usrGameCfgData && this.usrGameCfgData.length > 0) {
              let ind = this.usrGameCfgData.findIndex(obj => obj.name == 'feedback_text');
              if (ind == -1) {
                flagNoOp = true;
              }
            } else {
              flagNoOp = true;
            }
          }
        }
        if (flagNoOp) {
          this.cfgFeedBackFlag = true;
          this.isDisplayNotificationDivText.emit({ flag: false });
        } else {
          if (this.step_id) {
            this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id)
              .pipe(catchError((error) => { console.error('Error:', error); return of(); })).subscribe(async (res: any) => {
                this.gameTranscationMetadata = await res.data.transactionData;
                this.isAlertShow = true;
                this.showScoreResponse.emit({ isScoreShow: true, isComeFrom: 'playCharacter' });
                this.showEmbededComponents = true;
              });
          } else {
            this.gameTranscationMetadata = {};
            this.gameTranscationMetadata.score = this.characterSpeech.summaryFeedback.score;
            this.showEmbededComponents = true;
          }
          let cfgfedTxt = this.cfgFeedBackText;
          this.cfgFeedBackText = '';
          this.cfgFeedBackFlag = false;
          this.isDisplayNotificationDivText.emit({ flag: true });
          this.summeryFeedback = true;
          this.responseDisable = true;
          this.gameResponseDisable.emit({ response: this.responseDisable });
          if (parseInt(this.characterSpeech.summaryFeedback.score) == 100) {
            this.playScoreSound('scoreClap');
          } else {
            this.playScoreSound('score');
          }
          $('.showSingle').removeClass('modalFooterActiveBtn');
          $('#showSingle5').addClass('modalFooterActiveBtn');
          console.log("this.screenOrientataion", this.screenOrientataion);
          if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
            $(".mobileSlideHeader").removeClass("headerShow");
            $('.responseBgContainer').css('top', '0%');
            $('.commonModalFooter').css('display', 'flex');
            $('.gameContainer').css('height', 'calc(100vh - 66px)');
          }

          if (this.gameOverStatus == false) {
            this.gameFinished.emit({ finished: true, Score: this.characterSpeech.summaryFeedback.score, Path: this.currentGameResponse, Choice: this.currentGameChoices, feedback_text: cfgfedTxt });
          } else {
            this.gameKeyLearningSectionHide.emit(false);
          }


        }
      } else
        this.summeryFeedback = false;
      this.showScoreResponse.emit({ gameOver: false, isComeFrom: 'loadScene' })
    }
  }

  playCharacter(audioNum) {
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    //this.playResponseAudioFlag = false;
    clearInterval(this.defaultAnimationArray[this.tempArr[this.prefIndex]]);
    let charId = "myimg" + this.tempArr[this.prefIndex];
    let ctooltipId = "tooltip" + this.tempArr[this.prefIndex];
    let interIndex = this.interactionIndex++;
    let charImg = this.sceneCharacters[this.characterSpeech.characterSpeech[interIndex].name + '_' + this.characterSpeech.characterSpeech[interIndex].expression[this.expressionIndex]];
    let url = charImg ? charImg.src : '';
    let Frames = this.characterSpeech.characterSpeech[interIndex].frames[this.expressionIndex];
    let Fidelity = this.characterSpeech.characterSpeech[interIndex].fidelity[this.expressionIndex];
    // true if audio is there.
    //let isAudio = this.characterSpeech.characterSpeech[interIndex].audioFor.indexOf(this.expressionIndex.toLocaleString()) != -1;
    // total no of expression for character.
    let totalExpressions = this.characterSpeech.characterSpeech[interIndex].expression.length;
    let totalCharacters = this.characterSpeech.characterSpeech.length;
    for (let j = 0; j < this.defaultExpressionListWithName.length; j++) {
      if (this.defaultExpressionListWithName[j].name.toString() == charId.toString()) {
        clearInterval(this.defaultExpressionListWithName[j].val);
      }
    }
    let isAudio = this.sceneAudios[this.characterSpeech.characterSpeech[interIndex].audioFile[audioNum].split(".")[0]];
    // && this.characterSpeech.characterSpeech[interIndex].text[audioNum] != ""
    if (this.characterSpeech.characterSpeech[interIndex].text[audioNum] != "") {//isAudio &&
      // $("#" + ctooltipId).text(this.characterSpeech.characterSpeech[interIndex].text[audioNum]);
      $("#" + ctooltipId).html("<div class='tooltip-content-wrapper'>" + this.characterSpeech.characterSpeech[interIndex].text[audioNum] + "</div>");
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '12px');
      }
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '11px');
      }
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '10px');
      }
      let speechText = this.characterSpeech.characterSpeech[interIndex].text[audioNum];
      if (speechText && speechText != "") {
        $("#" + ctooltipId).css("display", "inline-block");
      } else {
        $("#" + ctooltipId).css("display", "none");
      }

      let name = this.characterSpeech.characterSpeech[interIndex].audioFile[audioNum];
      let duration;
      if (name && this.sceneAudios[name.split(".")[0]]) {
        duration = this.sceneAudios[name.split(".")[0]].duration * 1000;
        /*this.sceneAudios[name.split(".")[0]].play();
        this.sceneAudios[name.split(".")[0]].currentTime = 0;*/
        this.playGlobalAudio.emit({ name: name.split(".")[0] });
        this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
      } else {
        // duration = 5000;
        let txtForCnt = this.characterSpeech.characterSpeech[interIndex].text[0];
        let textLength = txtForCnt.length;
        if (textLength > 0) {
          if (textLength < 8) {
            let lowText = ((textLength / 2) * 1000) >= 1000 ? (textLength / 2) * 1000 : 750;
            duration = lowText;
            console.log("textLength---", textLength, "duration", duration);
          } else {
            let lowText = ((textLength / 8) * 1000) > 1000 ? (textLength / 8) * 1000 : 750;
            // duration = ((lowText / wordsPerMinute) * 60000) >= 1000 ? ((lowText / wordsPerMinute) * 60000) : lowText;
            duration = lowText;
            console.log("textLength---", textLength, "duration", duration);
          }
        } else {
          duration = 5000;
          console.log("textLength", textLength, "duration", duration);
        }
      }
      this.expressionWithAudio(charId, url, Frames, duration, Fidelity, () => {
        this.expressionIndex++;
        if (this.expressionIndex != totalExpressions) {
          audioNum++;
          if (this.characterSpeech.characterSpeech[this.interactionIndex].name == 'Narrator') {
            this.narratorCharacterPlay(audioNum);
          } else {
            if (this.tempArr[this.prefIndex] == "-1") {
              this.prefIndex++;
              this.interactionIndex++;
            }
            this.playCharacter(audioNum);
          }
        } else {

          let url = this.sceneCharacters[this.characterSpeech.characterSpeech[interIndex].name + '_' + this.characterSpeech.characterSpeech[interIndex].expression[0]].src;
          let Frames = this.characterSpeech.characterSpeech[interIndex].frames[0];
          let Fidelity = this.characterSpeech.characterSpeech[interIndex].fidelity[0];
          let defaultExp = this.characterSpeech.characterSpeech[interIndex].defaultExpression;
          this.prefIndex++;
          if (this.prefIndex != totalCharacters) {
            if (defaultExp == "true" || defaultExp == true) {
              this.defaultExpression(charId, url, Frames, Fidelity);
            } else {
              //clearInterval(this.clearDefaultExp[this.tempArr[this.prefIndex-1]]);
              $("#" + ctooltipId).css("display", "none");
            }
            this.loadScene();
          } else {
            if (defaultExp == "true" || defaultExp == true) {
              this.defaultExpression(charId, url, Frames, Fidelity);
            } else {
              //clearInterval(this.clearDefaultExp[this.tempArr[this.prefIndex-1]]);
              $("#" + ctooltipId).css("display", "none");
            }
            this.responseDisable = false;
            this.playResponseAudioFlag = true;
            this.gameResponseDisable.emit({ response: this.responseDisable });
            console.log("this.screenOrientataion", this.screenOrientataion);
            if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
              // $('.responseBgContainer').css('display','block');
              $('.responseBgContainer').css('top', '0%');
            }

            if (this.characterSpeech.endNode == 'true' || this.characterSpeech.endNode == true) {
              // this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id).pipe().subscribe(async (res: any) => {
              //   this.gameTranscationMetadata = await res.data.transactionData;
              //   this.isAlertShow = true;
              //   this.showScoreResponse.emit({ isScoreShow: true,isComeFrom:'playCharacter' });
              //   this.showEmbededComponents = true;
              // })
              if (this.step_id) {
                this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id)
                  .pipe(
                    catchError((error) => {
                      // Handle the error here
                      console.error('Error:', error);
                      // You can choose to return a default value or re-throw the error
                      return of(/* default value or appropriate fallback */);
                    })
                  )
                  .subscribe(async (res: any) => {
                    // Your success logic here
                    this.gameTranscationMetadata = await res.data.transactionData;
                    this.isAlertShow = true;
                    this.showScoreResponse.emit({ isScoreShow: true, isComeFrom: 'playCharacter' });
                    this.showEmbededComponents = true;
                  });
              } else {
                this.gameTranscationMetadata = {};
                this.gameTranscationMetadata.score = this.characterSpeech.summaryFeedback.score;
                this.showEmbededComponents = true;
              }


              let flagNoOp = false;
              if (this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Games && this.resConfig[0].Games.length > 0) {
                if (this.resConfig[0].Games[0].feedback_text && this.resConfig[0].Games[0].feedback_text.visible && this.no_of_attempts == 0) {
                  if (this.usrGameCfgData && this.usrGameCfgData.length > 0) {
                    let ind = this.usrGameCfgData.findIndex(obj => obj.name == 'feedback_text');
                    if (ind == -1) {
                      flagNoOp = true;
                    }
                  } else {
                    flagNoOp = true;
                  }
                }
              }
              if (flagNoOp) {// && this.cfgFeedBackText == ''
                this.cfgFeedBackFlag = true;
                this.isDisplayNotificationDivText.emit({ flag: false });
              } else {
                let cfgfedTxt = this.cfgFeedBackText;
                this.cfgFeedBackText = '';
                this.cfgFeedBackFlag = false;
                this.isDisplayNotificationDivText.emit({ flag: true });
                this.summeryFeedback = true;
                this.responseDisable = true;
                this.gameResponseDisable.emit({ response: this.responseDisable });
                if (parseInt(this.characterSpeech.summaryFeedback.score) == 100) {
                  this.playScoreSound('scoreClap');
                } else {
                  this.playScoreSound('score');
                }
                $('.showSingle').removeClass('modalFooterActiveBtn');
                $('#showSingle5').addClass('modalFooterActiveBtn');
                console.log("this.screenOrientataion", this.screenOrientataion);
                if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
                  $(".mobileSlideHeader").removeClass("headerShow");
                  $('.responseBgContainer').css('top', '0%');
                  $('.commonModalFooter').css('display', 'flex');
                  $('.gameContainer').css('height', 'calc(100vh - 66px)');
                }
                if (this.gameOverStatus == false) {
                  this.gameFinished.emit({ finished: true, Score: this.characterSpeech.summaryFeedback.score, Path: this.currentGameResponse, Choice: this.currentGameChoices, feedback_text: cfgfedTxt });
                } else {
                  this.gameKeyLearningSectionHide.emit(false);
                }

              }
            } else
              this.summeryFeedback = false;
            this.isAlertShow = false;
          }
        }
      });
    }
    else {
      $("#" + ctooltipId).text(this.characterSpeech.characterSpeech[interIndex].text[audioNum]);
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '12px');
      }
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '11px');
      }
      if ($("#" + ctooltipId).height() > 170) {
        $("#" + ctooltipId).css('font-size', '10px');
      }
      let speechText = this.characterSpeech.characterSpeech[interIndex].text[audioNum];
      if (speechText && speechText != "") {
        $("#" + ctooltipId).css("display", "inline-block");
      } else {
        $("#" + ctooltipId).css("display", "none");
      }
      this.expressionWithoutAudio(charId, url, Frames, Fidelity, () => {
        this.expressionIndex++;
        $("#" + charId).css('background-image', 'url("")');
        if (this.expressionIndex != totalExpressions) {
          if (this.characterSpeech.characterSpeech[this.interactionIndex].name == 'Narrator') {
            this.narratorCharacterPlay(audioNum);
          } else {
            if (this.tempArr[this.prefIndex] == "-1") {
              this.prefIndex++;
              this.interactionIndex++;
            }
            this.playCharacter(audioNum);
          }
        } else {
          let url = this.sceneCharacters[this.characterSpeech.characterSpeech[interIndex].name + '_' + this.characterSpeech.characterSpeech[interIndex].expression[0]].src;
          let Frames = this.characterSpeech.characterSpeech[interIndex].frames[0];
          let Fidelity = this.characterSpeech.characterSpeech[interIndex].fidelity[0];
          let defaultExp = this.characterSpeech.characterSpeech[interIndex].defaultExpression;
          this.prefIndex++;
          if (this.prefIndex != totalCharacters) {
            if (defaultExp == "true" || defaultExp == true) {
              this.defaultExpression(charId, url, Frames, Fidelity);
            } else {
              //clearInterval(this.clearDefaultExp[this.tempArr[this.prefIndex-1]]);
              $("#" + ctooltipId).css("display", "none");
            }
            this.loadScene();
          } else {
            if (defaultExp == "true" || defaultExp == true) {
              this.defaultExpression(charId, url, Frames, Fidelity);
            } else {
              //clearInterval(this.clearDefaultExp[this.tempArr[this.prefIndex-1]]);
              $("#" + ctooltipId).css("display", "none");
            }
            this.responseDisable = false;
            this.playResponseAudioFlag = true;
            this.gameResponseDisable.emit({ response: this.responseDisable });
            console.log("this.screenOrientataion", this.screenOrientataion);
            if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
              // $('.responseBgContainer').css('display','block');
              $('.responseBgContainer').css('top', '0%');
            }
            if (this.characterSpeech.endNode == 'true' || this.characterSpeech.endNode == true) {
              // this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id).pipe().subscribe(async (res: any) => {
              //   this.gameTranscationMetadata = await res.data.transactionData;
              //   this.showScoreResponse.emit({ isScoreShow: true, isComeFrom: 'playCharacter' });
              //   this.isAlertShow = true;
              //   this.showEmbededComponents = true;
              // })
              if (this.step_id) {
                this.journeyService.getGameTransactionData(this.step_id, this.userID, this.community_id, this.journey_id)
                  .pipe(
                    catchError((error) => {
                      // Handle the error here
                      console.error('Error:', error);
                      // You can choose to return a default value or re-throw the error
                      return of(/* default value or appropriate fallback */);
                    })
                  )
                  .subscribe(async (res: any) => {
                    // Your success logic here
                    this.gameTranscationMetadata = await res.data.transactionData;
                    this.isAlertShow = true;
                    this.showScoreResponse.emit({ isScoreShow: true, isComeFrom: 'playCharacter' });
                    this.showEmbededComponents = true;
                  });
              } else {
                this.gameTranscationMetadata = {};
                this.gameTranscationMetadata.score = this.characterSpeech.summaryFeedback.score;
                this.showEmbededComponents = true;
              }


              let flagNoOp = false;
              if (this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Games && this.resConfig[0].Games.length > 0) {
                if (this.resConfig[0].Games[0].feedback_text && this.resConfig[0].Games[0].feedback_text.visible && this.no_of_attempts == 0) {
                  if (this.usrGameCfgData && this.usrGameCfgData.length > 0) {
                    let ind = this.usrGameCfgData.findIndex(obj => obj.name == 'feedback_text');
                    if (ind == -1) {
                      flagNoOp = true;
                    }
                  } else {
                    flagNoOp = true;
                  }
                }
              }
              if (flagNoOp) {
                this.cfgFeedBackFlag = true;
                this.isDisplayNotificationDivText.emit({ flag: false });
              } else {
                let cfgfedTxt = this.cfgFeedBackText;
                this.cfgFeedBackText = '';
                this.cfgFeedBackFlag = false;
                this.isDisplayNotificationDivText.emit({ flag: true });
                this.summeryFeedback = true;
                this.responseDisable = true;
                this.gameResponseDisable.emit({ response: this.responseDisable });
                if (parseInt(this.characterSpeech.summaryFeedback.score) == 100) {
                  this.playScoreSound('scoreClap');
                } else {
                  this.playScoreSound('score');
                }
                console.log("this.screenOrientataion", this.screenOrientataion);
                if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
                  $(".mobileSlideHeader").removeClass("headerShow");
                  $('.responseBgContainer').css('top', '0%');
                  $('.commonModalFooter').css('display', 'flex');
                  $('.gameContainer').css('height', 'calc(100vh - 66px)');
                }
                if (this.gameOverStatus == false) {
                  this.gameFinished.emit({ finished: true, Score: this.characterSpeech.summaryFeedback.score, Path: this.currentGameResponse, Choice: this.currentGameChoices, feedback_text: cfgfedTxt });
                } else {
                  this.gameKeyLearningSectionHide.emit(false);
                }
              }
            } else
              this.summeryFeedback = false;
          }
        }
      });
    }
  }

  narratorCharacterPlay(audioNum) {
    let isAudio = this.characterSpeech.characterSpeech[this.interactionIndex].audioFor.indexOf(this.expressionIndex.toLocaleString()) != -1;
    let name = this.characterSpeech.characterSpeech[this.interactionIndex].audioFile[0];
    let duration;
    if (name && this.sceneAudios[name.split(".")[0]]) {
      duration = this.sceneAudios[name.split(".")[0]].duration * 1000;
      /*this.sceneAudios[name.split(".")[0]].play();
      this.sceneAudios[name.split(".")[0]].currentTime = 0;*/
      this.playGlobalAudio.emit({ name: name.split(".")[0] });
      this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
    } else {
      // duration = 5000;
      let txtForCnt = this.characterSpeech.characterSpeech[this.interactionIndex].text[0];
      let textLength = txtForCnt.length;
      if (textLength > 0) {
        if (textLength < 8) {
          let lowText = ((textLength / 2) * 1000) >= 1000 ? (textLength / 2) * 1000 : 750;
          duration = lowText;
          console.log("textLength---", textLength, "duration", duration);
        } else {
          let lowText = ((textLength / 8) * 1000) > 1000 ? (textLength / 8) * 1000 : 750;
          duration = lowText;
          console.log("textLength---", textLength, "duration", duration);
        }
      } else {
        duration = 5000;
        console.log("textLength", textLength, "duration", duration);
      }
    }
    $('.narratorDialogue').text(this.characterSpeech.characterSpeech[this.interactionIndex].text[0]);
    $('.narratorDialogue').css('display', 'block');
    let mySetTimeout = setTimeout(() => {
      this.prefIndex++;
      this.interactionIndex++;
      $('.narratorDialogue').css('display', 'none');
      if (this.characterSpeech.characterSpeech[this.interactionIndex]) {
        if (this.tempArr[this.prefIndex] == "-1") {
          this.prefIndex++;
          this.interactionIndex++;
        }
        this.playCharacter(audioNum);
      } else {
        if (this.tempArr[this.prefIndex] == "-1") {
          this.prefIndex++;
          this.interactionIndex++;
        }
        this.loadScene();
      }
    }, duration);
    this.timeOutsArray.push(mySetTimeout);
  }

  responseClick(linkTo, i) {
    console.log("linkTo array is", linkTo);
    console.log("i is", i);
    // this.sceneAudios = null;
    console.log("this.screenOrientataion", this.screenOrientataion);
    if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
      $('.responseBgContainer').css('top', '100%');
    }
    for (let j = 0; j < this.intervalsArray.length; j++) {
      clearInterval(this.intervalsArray[j]);
    }
    for (let j = 0; j < this.timeOutsArray.length; j++) {
      clearTimeout(this.timeOutsArray[j]);
    }
    for (let j = 0; j < this.defaultExpressionList.length; j++) {
      clearTimeout(this.defaultExpressionList[j]);
    }
    // Stop all played audios
    for (let i = 0; i < this.playedAudiosArray.length; i++) {
      this.playedAudiosArray[i].pause();
    }
    this.playedAudiosArray = [];
    this.intervalsArray = [];
    this.defaultExpressionList = [];
    this.timeOutsArray = [];
    this.defaultAnimationArray = [];
    let val = this.characterSpeech.feedbacks.find(obj => obj.id == i.id);
    let arr = [];
    if (val) {
      arr.push({ selectedResponse: val.id, feedback: val.value, linkTo: linkTo, title: this.characterSpeech.title });
    }

    if (linkTo == 'A' || linkTo == 'B' || linkTo == 'C') {
      this.currentGameChoices = [];
      this.currentGameResponse = 'Scene';
    }
    console.log("concated current game response", this.currentGameResponse.concat("-" + linkTo));
    console.log("responsesource input", arr);
    this.currentGameChoices.push(i.property);
    this.currentGameResponse = this.currentGameResponse.concat("-" + linkTo);
    this.responseSource.emit({ linkTo: linkTo, reviewArray: arr });
    console.log("this.characterSpeech.endNode", this.characterSpeech)
    var string = this.currentGameResponse;
    var count = string.split('-');
    let tendancyScene;
    if (count.length > 2) {
      tendancyScene = string.split('-')[1];
    } else {
      tendancyScene = string.split('-')[0];
    }
    let lastPart = count[count.length - 1];
    this.lastPart = lastPart;
  }

  playResponseAudio(option, optionNo) {

    console.log("in playAudio option data", option);

    let iOSVer = /iPad|iPhone|iPod/.test(navigator.platform);
    // if ((window.navigator.userAgent.match(/iP(hone|od|ad)/)) || iOSVer) {
    //   let name = "";
    //   if (name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
    //     this.playGlobalAudio.emit({ name: name.split(".")[0] });
    //     console.log("Audio file name iphone", name);
    //   }
    // } else {
    let name = option.audioFile;
    console.log("Audio file name", name);
    // alert("normal user  playing audio");
    if (name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      /*this.sceneAudios[name.split(".")[0]].play();
      this.sceneAudios[name.split(".")[0]].currentTime = 0;*/
      this.playGlobalAudio.emit({ name: name.split(".")[0] });
      this.playedAudiosArray.push(this.sceneAudios[name.split(".")[0]]);
    }

    // }

  }

  stopResponseAudio(option, optionNo) {
    let name = option.audioFile;
    if (name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      this.sceneAudios[name.split(".")[0]].pause();
      this.playedAudiosArray.pop();
    }
  }

  isAudioAvailable(option) {
    let name = option.audioFile;
    if (name && this.sceneAudios[name.split(".")[0]] && this.playResponseAudioFlag) {
      return true;
    } else {
      return false;
    }
  }

  stopOrPlayResponseAudio(e, option, optionNo) {
    e.stopPropagation();
    let name = option.audioFile.split(".")[0];
    this.playResponseAudioFlag ? this.playResponseAudioFlag = false : this.playResponseAudioFlag = true;
    if (this.sceneAudios[name.split(".")[0]]) {
      if (this.playResponseAudioFlag) {
        $('#option' + optionNo).removeClass('volOff-icon');
        $('#option' + optionNo).addClass('volOn-icon');
        /*        this.sceneAudios[name].play();
                this.sceneAudios[name].currentTime = 0;*/
        this.playGlobalAudio.emit({ name: name });
        this.playedAudiosArray.push(this.sceneAudios[name]);
      } else {
        $('#option' + optionNo).removeClass('volOn-icon');
        $('#option' + optionNo).addClass('volOff-icon');
        this.sceneAudios[name].pause();
      }
    } else {
      $('#option' + optionNo).removeClass('volOn-icon');
      $('#option' + optionNo).addClass('volOff-icon');
    }
  }
  selectResponseAudio(e, option, optionNo) {
    console.log('on tab selection');

  }
  getScore() {
    return parseInt(this.characterSpeech.summaryFeedback.score);
  }

  ngOnDestroy() {
    this.clearAllIntervals();
  }

  clearAllIntervals() {
    // Clear all set timeouts
    for (let j = 0; j < this.timeOutsArray.length; j++) {
      clearTimeout(this.timeOutsArray[j]);
    }
    // Clear all set intervals
    for (let j = 0; j < this.intervalsArray.length; j++) {
      clearInterval(this.intervalsArray[j]);
    }

    for (let j = 0; j < this.defaultExpressionList.length; j++) {
      clearInterval(this.defaultExpressionList[j]);
    }
    // Stop all played audios
    for (let i = 0; i < this.playedAudiosArray.length; i++) {
      this.playedAudiosArray[i].pause();
    }
    this.playedAudiosArray = [];
    this.intervalsArray = [];
    this.defaultExpressionList = [];
    this.timeOutsArray = [];
    this.defaultAnimationArray = [];
    this.reviewAndFeedBackArray = [];
  }

  playScoreSound(fileName) {
    // let fileName = "score";
    let file = this.sceneAudios[fileName];
    let duration;
    if (file) {
      /*file.currentTime = 0;
      file.play();*/
      this.playGlobalAudio.emit({ name: fileName });
      this.playedAudiosArray.push(file);
    }
  }

  addCfgFeedBackText() {
    this.isCfgFeedBackInvalid = false;
    this.cfgFeedBackText = this.cfgFeedBackText && this.cfgFeedBackText.length > 0 ? this.cfgFeedBackText.trim() : '';
    if (this.cfgFeedBackText && this.cfgFeedBackText.length > 0) {
      let obj = {
        name: 'feedback_text',
        data: this.cfgFeedBackText,
        is_completed: true
      };
      this.feedBackCFGText.emit({ text: this.cfgFeedBackText, flag: 'feedback_text' });
      this.usrGameCfgData.push(obj);
      this.no_of_attempts += 1;
      this.cfgFeedBackFlag = false;
      this.isDisplayNotificationDivText.emit({ flag: true });
      this.displaySummaryFeedback();
    } else {
      this.isCfgFeedBackInvalid = true;
    }
  }

  displaySummaryFeedback() {
    let cfgfedTxt = this.cfgFeedBackText;
    this.cfgFeedBackText = '';
    this.cfgFeedBackFlag = false;
    this.isDisplayNotificationDivText.emit({ flag: true });
    this.summeryFeedback = true;
    this.responseDisable = true;
    this.gameResponseDisable.emit({ response: this.responseDisable });
    if (parseInt(this.characterSpeech.summaryFeedback.score) == 100) {
      this.playScoreSound('scoreClap');
    } else {
      this.playScoreSound('score');
    }
    $('.showSingle').removeClass('modalFooterActiveBtn');
    $('#showSingle5').addClass('modalFooterActiveBtn');
    console.log("this.screenOrientataion", this.screenOrientataion);
    if (this.screenOrientataion == 90 && this.screenWidth < 1000) {
      $(".mobileSlideHeader").removeClass("headerShow");
      $('.responseBgContainer').css('top', '0%');
      $('.commonModalFooter').css('display', 'flex');
      $('.gameContainer').css('height', 'calc(100vh - 66px)');
    }

    if (this.gameOverStatus == false) {
      this.gameFinished.emit({ finished: true, Score: this.characterSpeech.summaryFeedback.score, Path: this.currentGameResponse, Choice: this.currentGameChoices, feedback_text: cfgfedTxt });
    } else {
      this.gameKeyLearningSectionHide.emit(false);
    }
  }

  openScoreboardModal() {
    this.notifyToGameCharacterComponent.emit(true)
  }
  mouseenter() {
    document.getElementById('scorcard-h').style.color = '#333333';
    document.getElementById('scorcard-i').style.filter = 'brightness(0.3)';
  }
  mouseleave() {
    document.getElementById('scorcard-h').style.color = '#F8941E';
    document.getElementById('scorcard-i').style.filter = '';
  }

  mouseenterToolTip(ev: any) {
    const elementValue = ev.target.innerHTML;
    const element = ev.target;
    console.log('element', element)
    console.log('elementValue', elementValue)
    if (element.id == 'score-donut') {
      this.showToolTip = true;
    }
    let value = element.getBoundingClientRect();
    setTimeout(() => {
      let tooltipEle = document.getElementById('score-buttton');
      if (tooltipEle) {
        tooltipEle!.style.top = 220 + 'px';
        tooltipEle!.style.left = 90 + 'px';
        tooltipEle.style.width = 160 + 'px';
      }
      if (tooltipEle)
        tooltipEle!.style.zIndex = '10000';
      let tooltipTextElement = document.getElementById('score-buttton-text');
      if (element.id == 'score-donut') {
        if (tooltipTextElement) {
          tooltipTextElement!.innerHTML = 'Total points achieved by selecting unique choices in the game.';
          tooltipTextElement!.style.padding = '10px';
        }
      }
      else {
        this.showToolTip = false;
      }
    }, 0)
  }

  mouseleaveToolTip(ev) {
    let tooltipTextElement = document.getElementById('score-buttton-text');
    if (tooltipTextElement)
      tooltipTextElement!.style.padding = '0px';

    const elementValue = ev.target.innerHTML;
    if (elementValue != '') {
      this.showToolTip = false;
    }
    else {
      this.showToolTip = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/game-characters/game-characters.component.ts